import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../Assets/Styles/Login.css";
import Logo from '../Assets/Images/proton.png';
import { Link } from 'react-router-dom';
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  /*const handleLogin = (e) => {
    e.preventDefault();
    const correctEmail = 'admin@protoneffect';
    const correctPassword = '123456';
   
    if (email === correctEmail && password === correctPassword) {
      localStorage.setItem('isLoggedIn', 'true'); 
      setError('');
      navigate('/home', { replace: true }); 
    } else {
      setError('Invalid email or password. Please try again.');
    }
  };*/

  
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://emailtool-backend-dev.protoneffect.net/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("Invalid email or password");
      }

      const data = await response.json();
      console.log("Login successful:", data);

     
      if (data.token) {
        localStorage.setItem("authToken", data.token);
      }
      localStorage.setItem("isLoggedIn", "true");
      
      navigate("/home", { replace: true });

    } catch (error) {
      setError(error.message);
      console.error("Login failed:", error);
    }
  };
  


  return (
    <div className='login'>
      <div className="session">
        <div className="left">
        <img src={Logo} alt="" className='login-logo' />
        </div>
        <form className="log-in" onSubmit={handleLogin}>
            <h1>Email Tool</h1>
          <h4>
            <span>Login</span>
          </h4>
          <p>Welcome back! Log in to Email marketing tool and start creating your email now</p>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <div className="floating-label">
            <input
              placeholder="Email"
              type="email"
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required
            />
            <label htmlFor="email">Email:</label>
          </div>
          <div className="floating-label">
            <input
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)} 
              required
            />
            <label htmlFor="password">Password:</label>
          </div>
          <button type="submit">Log in</button>
         {/* <div style={{textAlign:"center", width:'100%'}}>
           <Link to="/admin-login"> Login as Admin</Link>
          </div>*/}
        </form>
      </div>
    </div>
  );
};

export default Login;
